import { createContext } from 'react';
import { ColumnStatusMap } from '../../FoldingTable.types';

export const FoldingTableContext = createContext<{ opened: Set<string>; columnsStatuses: ColumnStatusMap }>({
  opened: new Set(),
  columnsStatuses: {},
});
export const FoldingTableContextProvider = FoldingTableContext.Provider;
